<div class="container-fluid glb-popup">
  <h2>{{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  @if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
  }

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">

      @if (formAlert) {
        <div class="col-lg-12 mb-3">
          <div style="text-align:center;background-color:yellow;padding:5px;">
            <p><b>{{formAlert}}</b></p>
          </div>
        </div>
      }

      <!-- Reason (grouped dropdown) -->
      <div class="col-lg-12 mb-3">
        <span class="p-float-label w-100">
          <p-dropdown class="w-100"
            [options]="reasonCodeGroups"
            [group]="true"
            optionGroupLabel="label"
            optionGroupChildren="items"
            optionLabel="label"
            optionValue="value"
            formControlName="reasonCode"
            [filter]="true"
            filterBy="label"
            placeholder="Select a reason"
            appendTo="body">
          </p-dropdown>
          <label>Reason *</label>
        </span>
        @for (validation of validationMessages.reasonCode; track validation) {
          @if (form1.get('reasonCode').hasError(validation.type) && (form1.get('reasonCode').dirty || form1.get('reasonCode').touched)) {
            <small class="p-invalid d-block mt-1">{{validation.message}}</small>
          }
        }
      </div>

      <!-- Refund Amount -->
      <div class="col-lg-6 mb-3">
        <span class="p-float-label w-100">
          <input formControlName="refundAmount" id="refundAmount" type="text" pInputText class="w-100">
          <label for="refundAmount">Refund Amount *</label>
        </span>
        @for (validation of validationMessages.refundAmount; track validation) {
          @if (form1.get('refundAmount').hasError(validation.type) && (form1.get('refundAmount').dirty || form1.get('refundAmount').touched)) {
            <small class="p-invalid d-block mt-1">{{validation.message}}</small>
          }
        }
      </div>

      <!-- Reason Description -->
      <div class="col-lg-12 mb-3">
        <span class="p-float-label w-100">
          <textarea formControlName="reasonDesc" id="reasonDesc" [rows]="3" pInputTextarea class="w-100"></textarea>
          <label for="reasonDesc">Description *</label>
        </span>
        @for (validation of validationMessages.reasonDesc; track validation) {
          @if (form1.get('reasonDesc').hasError(validation.type) && (form1.get('reasonDesc').dirty || form1.get('reasonDesc').touched)) {
            <small class="p-invalid d-block mt-1">{{validation.message}}</small>
          }
        }
      </div>

      @if (guestRefundReasonId) {
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown [options]="guestRefunds" formControlName="guestRefundId" appendTo="body"
              optionLabel="lastName" optionValue="guestRefundId" (onChange)="selectGuestRefund()"
              [filter]="true" filterBy="lastName" [showClear]="false" placeholder="Select Guest Refund">
            </p-dropdown>
            <label>Select Guest Refund</label>
            @if (guestRefundIdRequired) {
              <small class="p-invalid d-block mt-1">Guest refund is required.</small>
            }
          </span>
        </div>
      }

    </div>
  </div>
  <hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (guestRefundReasonId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
              [disabled]="formLoading" (click)="onFormDelete()">Delete</button>
          }
        </div>
        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [disabled]="formLoading" [mat-dialog-close]="formLoading ? null : true">Cancel</button>
          @if (!guestRefundReasonId) {
            <button pButton class="btn-addt p-button" [disabled]="formLoading || addCompleted" (click)="formAdd()">
              @if (formLoading) { <i class="pi pi-spin pi-spinner mr-1"></i> } Add
            </button>
          }
          @if (guestRefundReasonId) {
            <button pButton class="btn-upt p-button" [disabled]="formLoading" (click)="formUpdate()">
              @if (formLoading) { <i class="pi pi-spin pi-spinner mr-1"></i> } Update
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
